const Images = {
  // greenline: require("../Assets/images/greenline.json"),
  // infoweb: require("../Assets/images/infoweb.json"),
  // infomobile: require("../Assets/images/infomobile.json"),
  // infostar: require("../Assets/images/star.json"),
  // headline: require("../Assets/images/headline.json"),
  // trust: require("../Assets/images/trust.json"),
  // infobg: require("../Assets/images/infobg.json"),
  // featurebg: require("../Assets/images/featurebg.json"),
  // featurevertical: require("../Assets/images/featurevertical.json"),
  // featimgone: require("../Assets/images/featimgone.svg").default,
  // featimgtwo: require("../Assets/images/featimgtwo.svg").default,
  // featimgthree: require("../Assets/images/featimgthree.svg").default,
  // featimgfour: require("../Assets/images/featimgfour.svg").default,
  // featlogo: require("../Assets/images/featlogo.json"),
  // clients: require("../Assets/images/clients.json"),
  // clientsbg: require("../Assets/images/clientsbg.json"),
  // roadmapbg: require("../Assets/images/roadmapbg.json"),
  // telegram: require("../Assets/images/telegram.svg").default,
  // twitter: require("../Assets/images/twitter.svg").default,
  // instagram: require("../Assets/images/instagram.svg").default,
  // discord: require("../Assets/images/discord.svg").default,
  // flogo: require("../Assets/images/flogo.png").default,
  // bannercenter: require("../Assets/images/bannercenter.json"),
  // bannercenterlines: require("../Assets/images/bannercenterlines.json"),
  // innerimg: require("../Assets/images/innerimg.json"),
  // launchlines: require("../Assets/images/launchlines.gif").default,

  // feathead: require("../Assets/images/feathead.png"),
  // featbody: require("../Assets/images/featbody.png"),

  // partnersimg: [
  //     { partnerimg: require("../Assets/images/client1.png").default },
  //     { partnerimg: require("../Assets/images/client2.png").default },
  //     { partnerimg: require("../Assets/images/client3.png").default },
  //     { partnerimg: require("../Assets/images/client4.png").default },
  //     { partnerimg: require("../Assets/images/client5.png").default },
  //     { partnerimg: require("../Assets/images/client6.png").default },
  //     { partnerimg: require("../Assets/images/client7.png").default },
  //     { partnerimg: require("../Assets/images/client8.png").default },
  //     { partnerimg: require("../Assets/images/client9.png").default },
  //     { partnerimg: require("../Assets/images/client10.png").default },
  //     { partnerimg: require("../Assets/images/client11.png").default },
  //     { partnerimg: require("../Assets/images/client12.png").default },

  // ],

  // client1: require("../Assets/images/client1.png").default,
  // client2: require("../Assets/images/client2.png").default,
  // client3: require("../Assets/images/client3.png").default,
  // client4: require("../Assets/images/client4.png").default,
  // client5: require("../Assets/images/client5.png").default,
  // client6: require("../Assets/images/client6.png").default,
  // client7: require("../Assets/images/client7.png").default,
  // client8: require("../Assets/images/client8.png").default,
  // client9: require("../Assets/images/client9.png").default,
  // client10: require("../Assets/images/client10.png").default,
  // client11: require("../Assets/images/client11.png").default,
  // client12: require("../Assets/images/client12.png").default,

  // whitepaperone: require("../Assets/images/whitepaper/whitepaperone.png")
  //   .default,
  // whitepapertwo: require("../Assets/images/whitepaper/whitepapertwo.png")
  //   .default,
  // whitepaperthree: require("../Assets/images/whitepaper/whitepaperthree.png")
  //   .default,
  // whitepaperfour: require("../Assets/images/whitepaper/whitepaperfour.png")
  //   .default,
  // whitepaperfive: require("../Assets/images/whitepaper/whitepaperfive.png")
  //   .default,
  // whitepapersix: require("../Assets/images/whitepaper/whitepapersix.png")
  //   .default,
  // whitepaperseven: require("../Assets/images/whitepaper/whitepaperseven.png")
  //   .default,
  // whitepapereight: require("../Assets/images/whitepaper/whitepapereight.png")
  //   .default,
  // whitepapernine: require("../Assets/images/whitepaper/whitepapernine.png")
  //   .default,
  // whitepaperten: require("../Assets/images/whitepaper/whitepaperten.png")
  //   .default,
  // whitepapereleven: require("../Assets/images/whitepaper/whitepapereleven.png")
  //   .default,
  // whitepapertwelve: require("../Assets/images/whitepaper/whitepapertwelve.png")
  //   .default,

  // imageone: require("../Assets/images/philosophy/imageone.png").default,
  // imagetwo: require("../Assets/images/philosophy/imagetwo.gif").default,
  // imagethree: require("../Assets/images/philosophy/imagethree.png").default,
  // imagefour: require("../Assets/images/philosophy/imagefour.gif").default,
  // imagefive: require("../Assets/images/philosophy/imagefive.png").default,
  // imagesix: require("../Assets/images/philosophy/imagesix.png").default,
  // imageseven: require("../Assets/images/philosophy/imageseven.gif").default,
  // imageeight: require("../Assets/images/philosophy/imageeight.gif").default,
  // imagenine: require("../Assets/images/philosophy/imagenine.gif").default,
  // imageten: require("../Assets/images/philosophy/imageten.gif").default,
  // imageeleven: require("../Assets/images/philosophy/imageeleven.gif").default,
  // imagetwelve: require("../Assets/images/philosophy/imagetwelve.gif").default,
  // imagethirteen: require("../Assets/images/philosophy/imagethirteen.gif")
  //   .default,
  // imagefourteen: require("../Assets/images/philosophy/imagefourteen.gif")
  //   .default,

  /** ainfra source */

  banner_right_circle:
    require("../Assets/ainfra/images/banner_right_circle.svg").default,
  banner_left_circle: require("../Assets/ainfra/animation/banner_left_circle.gif"),
  banner_logo: require("../Assets/ainfra/images/banner_logo.svg").default,
  header_logo: require("../Assets/ainfra/images/logo.svg").default,
  green_up_arrow: require("../Assets/ainfra/images/green_up_arrow.svg").default,

  // depin

  depinBannerGif: require("../Assets/ainfra/images/depin/banner.mp4").default,
  depinBannerBg: require("../Assets/ainfra/images/depin/banner_bg.svg").default,
  depintxt: require("../Assets/ainfra/images/depin/dePin.svg").default,
  hiw1: require("../Assets/ainfra/images/depin/hiw_1.svg").default,
  hiw2: require("../Assets/ainfra/images/depin/hiw_2.svg").default,
  hiw3: require("../Assets/ainfra/images/depin/hiw_3.svg").default,
  hiw4: require("../Assets/ainfra/images/depin/hiw_4.svg").default,
  smartStorage: require("../Assets/ainfra/images/depin/smart_storage.mp4")
    .default,
  distributeDelivery:
    require("../Assets/ainfra/images/depin/distribute_delivery.gif").default,
  transcoding: require("../Assets/ainfra/images/depin/transcoding.gif").default,
  chip: require("../Assets/ainfra/images/depin/chip.gif").default,
  appDemo: require("../Assets/ainfra/images/depin/app_demo.svg").default,
  storage_banner_bg: require("../Assets/ainfra/images/storage/banner_bg.mp4")
    .default,
  how_it_works_video: require("../Assets/ainfra/videos/how_works.mp4")
    .default,
  banner_left_ball_video: require("../Assets/ainfra/videos/banner_left_ball.mp4")
    .default,

  banner_right_circle: require("../Assets/ainfra/images/banner_right_circle.svg").default,
  banner_left_circle: require("../Assets/ainfra/animation/banner_left_circle.gif"),
  banner_logo: require("../Assets/ainfra/images/banner_logo.svg").default,
  header_logo: require("../Assets/ainfra/images/logo.svg").default,
  green_up_arrow: require("../Assets/ainfra/images/green_up_arrow.svg").default,
  imperial: require("../Assets/ainfra/images/imperial.svg").default,
  imperial_hover: require("../Assets/ainfra/images/imperialHover.svg").default,
  adelaide: require("../Assets/ainfra/images/adelaide.svg").default,
  adelaide_hover: require("../Assets/ainfra/images/adelaideHover.svg").default,
  vinai: require("../Assets/ainfra/images/vinai.svg").default,
  vinai_hover: require("../Assets/ainfra/images/vinaiHover.svg").default,
  liverpool: require("../Assets/ainfra/images/liverpool.svg").default,
  liverpool_hover: require("../Assets/ainfra/images/liverpoolHover.svg").default,
  framework: require("../Assets/ainfra/images/framework.svg").default,
  metamask: require("../Assets/ainfra/images/metamask.svg").default,
  framework: require("../Assets/ainfra/images/framework.svg").default,
  a16z: require("../Assets/ainfra/images/a16z.svg").default,
  pantera: require("../Assets/ainfra/images/pantera.svg").default,
  panteraPng: require("../Assets/ainfra/images/pantera.png"),
  sequo: require("../Assets/ainfra/images/sequo.svg").default,
  foresight: require("../Assets/ainfra/images/foresight.svg").default,
  digitalCurrency: require("../Assets/ainfra/images/digitalCurrency.svg").default,
  kleiner: require("../Assets/ainfra/images/kleiner.svg").default,



  latestNewsOne: require("../Assets/ainfra/images/latestNewsOne.png"),
  readMoreArrow: require("../Assets/ainfra/images/readMoreArrow.svg").default,

  audio: require("../Assets/ainfra/images/storage/audio.png").default,
  video: require("../Assets/ainfra/images/storage/video.svg").default,
  image: require("../Assets/ainfra/images/storage/image.svg").default,
  text: require("../Assets/ainfra/images/storage/text.svg").default,
  files: require("../Assets/ainfra/images/storage/file.svg").default,
  dev_depin: require("../Assets/ainfra/images/storage/depin_bg.gif").default,
  codeWritter: require("../Assets/ainfra/images/storage/code_writter.png").default,
  pricing: require("../Assets/ainfra/images/storage/pricing.gif").default,
  howItWorks: require("../Assets/ainfra/images/storage/how_it_works.gif").default,


};

export default Images;
